import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../common/components/Input";
import { updateShipmentDate } from "../../../api/caseApi";
import { shipSet } from "../../../api/caseApi";
import { updateFabricationAndShipmentDateSchema } from "../schema/updateDueDateSchema copy";
const UpdateShipmentDateDialog = ({
  openUpdateShipmentDate,
  handleCloseUpdateShipmentDate,
  caseProgressId,
  getSetsInfo,
  openUpdateShipmentDateFromShipSet,
  handleSetOpenUpdateShipmentDateFromShipSet,
}) => {
  const {
    handleSubmit,
    formState: { isSubmitting },
    reset,
    control,
  } = useForm({
    resolver: yupResolver(updateFabricationAndShipmentDateSchema),
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseProgressId = caseProgressId;
    // defaultValues.dateTime = f2fConsultationInfo.ShipmentDate ?? null;
    reset({ ...defaultValues });
  }, [caseProgressId, reset]);

  const submitUpdateShipment = async (values) => {
    await updateShipmentDate(values);
    if (openUpdateShipmentDateFromShipSet) {
      await shipSet(caseProgressId).then(() => {
        getSetsInfo();
      });
    } else {
      await getSetsInfo();
    }
    handleSetOpenUpdateShipmentDateFromShipSet();
    handleCloseUpdateShipmentDate();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateShipmentDate}
        onClose={handleCloseUpdateShipmentDate}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Shipment Date</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateShipment)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={7}>
                <DateInput
                  label="Date"
                  name="datetime"
                  control={control}
                  disableFuture={false}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              onClick={() => {
                handleCloseUpdateShipmentDate();
                handleSetOpenUpdateShipmentDateFromShipSet();
              }}
              disabled={isSubmitting}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateShipmentDateDialog;
